import sharedReactSetup from "app/scripts/shared_react_setup"
import "shared/utils/initialize_highcharts"
import { applePost, facebookSSO } from "shared/sso"
import AdminLayover from "app/scripts/admin_layover"
import BuildAutomationDropdown from "app/scripts/build_automation_dropdown"
import DynamicConfigurationToggle from "app/scripts/dynamic_configuration_toogle"
import HandleVerifyDeleteAccountByEmail from "app/scripts/handle_verify_delete_account_by_email"
import PushNotification from "app/scripts/push_notification"
import ServiceTabs from "app/scripts/service_tabs"
import TqaListTabs from "app/scripts/tqa_list_tabs"
import { setDatadogRumContext } from "app/scripts/shared_setup"
import SetupActivityFeed from "app/scripts/setup_activity_feed"
import SetupDeleteAccountSurvey from "app/scripts/setup_delete_account_survey"
import SetupUnifiedHeaderDropdown from "shared/scripts/setup_unified_header_dropdown"
import SetupUnifiedMobileMenu from "shared/scripts/setup_unified_mobile_menu"
import TFASendPin from "app/scripts/tfa_send_pin"
import UpdateParam from "app/scripts/update_param"
import { initializeSharing } from "app/scripts/sharing"

import handleRecaptcha from "shared/handle_recaptcha"
import AlreadySignedInPage from "app/components/sdk/already_signed_in_page"
import ConfigurePage from "app/components/sdk/configure_page"
import ConnectedServicePage from "app/components/sdk/connected_service_page"
import LandingPage from "app/components/sdk/landing_page"
import RefreshFormAuthenticityToken from "app/scripts/refresh_form_authenticity_token"
import ResetPasswordPage from "app/components/sdk/reset_password_page"
import SignInPage from "app/components/sdk/sign_in_page"
import SignUpPage from "app/components/sdk/sign_up_page"

import ActivateServiceWithModularAuth from "app/components/activate_service/activate_service_with_modular_auth"
import ActivateServiceWithPin from "app/components/activate_service/activate_service_with_pin"
import ActivateServiceWithToken from "app/components/activate_service/activate_service_with_token"
import ActivateWordpress from "app/components/activate_service/activate_wordpress"

// Generic Helper components
import PasswordUnmasking from "shared/scripts/password_un_masking"

// Page Specific Components
import ActivitySteps from "app/components/activity_steps"
import SLAPrompt from "shared/components/sla_prompt"

// Stored Fields
import IngredientTextField from "shared/components/stored_fields/ingredient_text_field/index"

import ConnectSDKAppletConfig from "app/components/connect_sdk_applet/config"
import ConnectionCard from "shared/components/connection_card"
import ConnectionConfig from "shared/components/connection_card/config"
import ConnectButton from "shared/components/connection_card/connect_button"
import ConnectionCardTitle from "shared/components/connection_card/title"
import AppletFeedback from "app/components/platform_feedback/applet_feedback"
import ReturningUserFlow from "app/components/connect_sdk_applet/returning_user_flow"
import TransitionAndRedirect from "app/components/connect_sdk_applet/returning_user_flow/transition_and_redirect"

import MyServiceSettingsView from "app/components/ifttt_next/services/my_service_settings_view/index"
import Profile from "app/components/ifttt_next/profile/index"
import GatedServiceAuthButton from "app/components/gated_service_auth_button"
import LearnMoreButton from "shared/components/learn_more_button"

import BillingSwitchPlanLink from "app/components/billing/switch_plan/index.tsx"
import BillingCancelContainer from "app/components/billing/cancel/index.tsx"
import PromotionContainer from "app/components/billing/cancel/promotion/index.tsx"
import ReferralCode from "app/components/referral/index.tsx"
import Rewards from "app/components/referral/rewards/index.tsx"
import ReceiptSettings from "app/components/billing/receipt_settings"

import FeedbackPrompt from "app/components/feedback_prompt/index.tsx"

import ProsumerHome from "app/components/prosumer_home"
import PlanUpgradeButton from "app/components/plan_upgrade_button"
import SignUpAndPurchase from "app/components/subscriptions/sign_up_and_purchase"
import UpdatePaymentInfo from "app/components/subscriptions/update_payment_info/index"
import Container from "app/components/connect_url"
import DIY from "app/components/diy_composer"

import "stylesheets/application.scss"

sharedReactSetup()

document.addEventListener("DOMContentLoaded", function() {
  initializeSharing()
}, { once: true })

Object.assign(window.App.Comps, {
  // React components
  ActivateServiceWithPin,
  ActivateServiceWithToken,
  ActivateServiceWithModularAuth,
  ActivateWordpress,
  ActivitySteps,
  AppletFeedback,
  BillingCancelContainer,
  DIY,
  PromotionContainer,
  ReferralCode,
  Rewards,
  BillingSwitchPlanLink,
  FeedbackPrompt,
  GatedServiceAuthButton,
  IngredientTextField,
  LearnMoreButton,
  MyServiceSettingsView,
  Profile,
  ReceiptSettings,
  SLAPrompt,
  PlanUpgradeButton,
  Subscriptions: {
    SignUpAndPurchase,
    UpdatePaymentInfo,
  },
  Sdk: {
    AlreadySignedInPage,
    ConfigurePage,
    ConnectedServicePage,
    LandingPage,
    ResetPasswordPage,
    SignInPage,
    SignUpPage,
  },
  Access: {
    ConnectSDKAppletConfig,
    ReturningUserFlow,
    TransitionAndRedirect,
  },
  ConnectionCard: {
    ConnectionCard,
    ConnectionConfig,
    ConnectButton,
    Title: ConnectionCardTitle,
  },
  ConnectURL: { Container},
})

// Per-page functions to setup non-react behavior
Object.assign(window.App.Scripts, {
  AdminLayover,
  applePost,
  BuildAutomationDropdown,
  DynamicConfigurationToggle,
  facebookSSO,
  handleRecaptcha,
  HandleVerifyDeleteAccountByEmail,
  PasswordUnmasking,
  ProsumerHome,
  PushNotification,
  RefreshFormAuthenticityToken,
  ServiceTabs,
  SetDatadogRumContext: setDatadogRumContext,
  TqaListTabs,
  SetupActivityFeed,
  SetupDeleteAccountSurvey,
  SetupUnifiedHeaderDropdown,
  SetupUnifiedMobileMenu,
  TFASendPin,
  UpdateParam,
})
